import { render, staticRenderFns } from "./HomeMain.vue?vue&type=template&id=44c884fe&scoped=true&"
import script from "./HomeMain.vue?vue&type=script&lang=ts&"
export * from "./HomeMain.vue?vue&type=script&lang=ts&"
import style0 from "./HomeMain.vue?vue&type=style&index=0&id=44c884fe&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c884fe",
  null
  
)

export default component.exports